import type { LOGIN_PROVIDERS } from 'types/enums.ts';
import type { Languages } from './translator';

export enum AuthFlow {
  Internal = 'internal',
  Supplier = 'supplier',
}

export interface AuthState {
  refreshToken?: string | null;
  tokenProvider?: LOGIN_PROVIDERS | null;
  jwtToken: string | null;
  apiKey?: string | null;
  idToken?: string | null;
  authFlow?: AuthFlow | null;
  keycloakRefreshToken?: string | null;
}

export type LanguageSliceType = {
  language: Languages;
  availableLanguages: Languages[];
};

export type BasicFilter<T = Record<string, unknown>> = {
  page: number;
  pageSize: number | null;
  orderBy: keyof T;
  orderDesc: boolean;
  search: string;
};

export interface BasePagedResponse {
  page: number;
  pageSize: number;
  totalCount: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

interface UseQueryResult<Data> {
  originalArgs?: unknown;
  data?: Data;
  error?: unknown;
  requestId?: string;
  endpointName?: string;
  startedTimeStamp?: number;
  fulfilledTimeStamp?: number;
  isUninitialized: boolean;
  isLoading: boolean;
  isFetching: boolean;
  isSuccess: boolean;
  isError: boolean;
  refetch: () => void;
}

export type UseQuerySelectorResult<Data> = Omit<UseQueryResult<Data>, 'refetch'>;
